import type {
  CounterConfig,
  CounterDayData,
  WidgetConfig,
  WidgetWeekEntry,
} from "@/lib/schema";
import { countPhrase, sumOverDays } from "@/widgets/describe";
import { getWidgetModule } from "@/widgets/registry";
import type { DayWidgetModule } from "@/widgets/types";
import { DayView } from "./DayView";
import { SettingsEditor } from "./SettingsEditor";
import { maxScoreWeek, scoreDay, scoreWeek } from "./scoring";
import { validate } from "./validate";

function defaults(existing: WidgetConfig[]): CounterConfig {
  const dayWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "day",
  );
  const maxRow = dayWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "counter",
    label: "Teller",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    points: 1,
    maxPoints: Number.NaN,
    weekGoal: Number.NaN,
  };
}

// Days actually counted on. A day left at zero reads exactly like a day never
// touched, so it is not something the week loses.
function describeWeekData(entry: WidgetWeekEntry): string | null {
  const days = sumOverDays<CounterDayData>(entry, (day) =>
    (day?.count ?? 0) > 0 ? 1 : 0,
  );
  return countPhrase(days, "dag med telling", "dager med telling");
}

export const counter: DayWidgetModule<CounterConfig> = {
  kind: "counter",
  label: "Teller",
  scope: "day",
  scoring: "points",
  defaults,
  validate,
  SettingsEditor,
  DayView,
  describeWeekData,
  scoreDay,
  scoreWeek,
  maxScoreWeek,
};
